/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S6_Li2Inputs */

const tr_servis_s6_li2 = /** @type {(inputs: Servis_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV (sipariş, fatura, müşteri listeleri)`)
};

const en_servis_s6_li2 = /** @type {(inputs: Servis_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV (order, invoice, customer lists)`)
};

const de_servis_s6_li2 = /** @type {(inputs: Servis_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV (Bestell-, Rechnungs- und Kundenlisten)`)
};

const ru_servis_s6_li2 = /** @type {(inputs: Servis_S6_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV (списки заказов, счетов, клиентов)`)
};

/**
* | output |
* | --- |
* | "CSV (order, invoice, customer lists)" |
*
* @param {Servis_S6_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s6_li2 = /** @type {((inputs?: Servis_S6_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S6_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s6_li2(inputs)
	if (locale === "de") return de_servis_s6_li2(inputs)
	if (locale === "ru") return ru_servis_s6_li2(inputs)
	return tr_servis_s6_li2(inputs)
});